<template>
  <v-container>
    <v-layout row align-center justify-center>
      <v-flex xs12 sm12 md10>
        <v-form @submit.prevent="handleSearch">
          <v-card color="primary">
            <v-card-text>
              <h3 class="mb-2">Enter Barcode, SKU, or Serial</h3>

              <v-text-field v-model="searchText" color="secondary" label="Search..." box autofocus></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-layout align-center row justify-space-around>
                <h3 class="mx-2">
                  <strong>{{totalQuantity}}</strong> Total
                </h3>
                <v-spacer />
                <v-btn color="secondary" depressed type="submit" :loading="loading">Locate</v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>

    <v-layout row align-center justify-center class="my-2">
      <v-flex xs12 sm12 md10 v-if="productName">
        <v-card color="primary">
          <v-card-text class="text-xs-center">
            <h3>{{!isLot ? productName : 'Lot/Serial: ' + lotSerial}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row align-center justify-center>
      <v-flex xs12 sm12 md10>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(location, index) in headers"
            :key="index"
            class="primary mb-1"
          >
            <template v-slot:header>
              <div>
                <h4>
                  {{location}}
                  <strong>({{totalRowQuantity(data[location])}})</strong>
                </h4>
              </div>
            </template>
            <v-card color="primary my-1" v-for="(product, index) in data[location]" :key="index">
              <v-card-text class="ml-4">
                <span v-if="isLot">
                  Product:
                  <strong>{{product.product_id[1].substr(0, 65)}}</strong>
                </span>
                <br v-if="isLot" />Quantity:
                <strong>{{product.quantities}}</strong>
                <span v-if="product.lot_id[1]">
                  <br />Lot/Serial:
                  <strong>{{product.lot_id[1]}}</strong>
                </span>
                <br />Owner:
                <strong>{{product.owner_id[1]}}</strong>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      searchText: "",
      products: 0,
      lotSerial: ""
    };
  },

  computed: {
    ...mapGetters({
      data: "productLocator/getData",
      loading: "app/isLoading",
      totalQuantity: "productLocator/getTotalQuantity",
      productName: "productLocator/getProductName",
      isLot: "productLocator/getIsLot"
    }),
    headers() {
      return Object.keys(this.data);
    }
  },
  methods: {
    handleSearch() {
      this.$store.dispatch("productLocator/search", this.searchText.trim());
      this.lotSerial = this.searchText;
    },
    totalRowQuantity(item) {
      let quantity = 0;
      item.forEach(product => {
        quantity += product.quantities;
      });

      return quantity;
    }
  }
};
</script>
